import { Injectable, inject } from '@angular/core';
import { Event, EventType, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';

class NavE extends NavigationEnd {
  constructor(id: number, url: string, urlAfterRedirects: string, public previousUrl?: string) {
    super(id, url, urlAfterRedirects);
  }
}

@Injectable({ providedIn: 'root' })
export class NavigationService {

  private router = inject(Router);

  navigation$: Observable<any> = this.router.events.pipe(
    filter((event: any) => {
      if (event.type === EventType.NavigationEnd) {
        return true;
      }

      return false;
    }),
    map((event: NavigationEnd) => {
      this.previousPath = this.currentPath;
      this.currentPath = event.urlAfterRedirects;


      return new NavE(event.id, event.url, event.urlAfterRedirects, this.previousPath);
    }),
    shareReplay()
  );

  private previousPath?: string;
  private currentPath?: string;
}
